
import React from "react";
import { FaWhatsapp, FaPhoneAlt, FaEnvelope } from "react-icons/fa";

const FloatingIcons = () => {
  return (
    <div className="fixed right-4 bottom-20 flex flex-col gap-4 z-50">
      {/* WhatsApp */}
      <a
        href="https://wa.me/971554421108?text=Hello%20Blue%20Diamond%20Rent%20a%20Car%2C%20I%20would%20like%20to%20enquire%20about%20your%20cars."
        target="_blank"
        rel="noopener noreferrer"
        className="w-12 h-12 flex items-center justify-center  rounded-full bg-green-500 text-white shadow-2xl hover:scale-110 transition"
      >
        <FaWhatsapp size={24} />
      </a>

      {/* Call */}
      <a
        href="tel:+97143974755"
        className="w-12 h-12 flex items-center justify-center  rounded-full bg-blue-600 text-white shadow-2xl hover:scale-110 transition"
      >
        <FaPhoneAlt size={22} />
      </a>

      {/* Gmail */}
      <a
        href="mailto:sales@bluediamondrentcar.com"
        className="w-12 h-12 flex items-center justify-center  rounded-full bg-red-500 text-white shadow-2xl hover:scale-110 transition"
      >
        <FaEnvelope size={22} />
      </a>
    </div>
  );
};

export default FloatingIcons;
